import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { BaseButtons, ButtonsLoaderModule } from 'buttons-loader';
import { AuthorizationModule } from 'authorization';
import { MenuItem } from 'primeng/api';
import { AuthenticationRoute } from 'src/domains/authentication/authentication.route';
import { FaqRoute } from 'src/domains/site-managment/app/feature/faq/faq.route';
import { SiteManagmentRoute } from 'src/domains/site-managment/site-managment.route';
import { HeaderRouteStrartegy } from 'src/domains/theme/service/header-route-strategy.service';
import { HeaderTemplateService } from 'src/domains/theme/service/header-template.service';
import { MenubarModule } from 'primeng/menubar';
import { filter, first, map, of, switchMap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppUserRequest } from 'src/domains/authentication/model/app-user/app-user.request';
import { UserService } from 'src/domains/share/app/service/user/user.service';
import { JwtAuthTokenService } from 'angular-jwt-auth';
import { AppUserModel } from 'src/domains/authentication/model/app-user/app-user.model';
import { LoginRequest } from 'src/domains/authentication/model/login-auth/login.request';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { BadgeModule } from 'primeng/badge';

import { environment } from 'src/environments/environment';
import { ConvertCurrencyPipe } from 'convert-currency';
import { ButtonModule } from 'primeng/button';
import { ImageOptimizerDirective } from 'lazy-load-image';
import { TieredMenuComponent } from '../../../../../app/src/domains/theme/app/component/tiered-menu/tiered-menu.component';
import { Router } from '@angular/router';

export interface SimpleMenuItem {
  label?: string;
  icon?: string;
  separator?: boolean;
  templateRef?: any; // TemplateRef from parent
  routerLink?: string | any[];
  command?: (event?: MouseEvent) => void;
  styleClass?: string;
  // any other fields you need
}
@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  imports: [
    AuthorizationModule,
    CommonModule,
    MenubarModule,
    ButtonsLoaderModule,
    TieredMenuModule,
    BadgeModule,
    ConvertCurrencyPipe,
    ButtonModule,
    ImageOptimizerDirective,
  ],
})
export class AppHeaderComponent implements OnInit {
  @ViewChild('headerElement', { static: false }) header!: ElementRef;
  @ViewChild('itemsLink', { read: ViewContainerRef, static: true })
  itemsLink: ViewContainerRef;
  @ViewChild('menu')
  menu: TieredMenuComponent;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 0) {
      this.isScrolled = true;
    } else if (scrollPosition === 0) {
      this.isScrolled = false;
    }
  }
  startHeaderTemplate: TemplateRef<any>;
  itemHeaderTemplate: TemplateRef<any>;
  endHeaderTemplate: TemplateRef<any>;
  buttonNavigateTemplate: TemplateRef<any>;
  @ViewChild('walletPannelMenu', { static: true })
  walletPannelMenuRef: TemplateRef<any>;

  @ViewChild('notificationPannelMenu', { static: true })
  notifPannelMenuRef: TemplateRef<any>;

  isScrolled = false;
  items: MenuItem[];

  home = SiteManagmentRoute.map.root;
  panelView = SiteManagmentRoute.map.dashboard.panel_menu;

  isAuthenticated: boolean = false;
  user: AppUserModel.Full;

  toggleMenu: boolean = false;
  dropDownOptions: MenuItem[] = [];

  @ViewChild('panel', { read: ElementRef, static: true }) panel!: ElementRef;
  opened = false;
  private lastTriggerEl?: Element;
  //   {
  //     type: 'class',
  //     link: {
  //       label: 'پروژه ها',
  //       newTab: false,
  //       url: ProjectsRoute.map.mainpage.view_project_list.path,
  //     },
  //   },
  //   {
  //     type: 'class',
  //     link: {
  //       label: 'تالار خرید و فروش',
  //       newTab: false,
  //       url: ShoppingHallRoute.map.mainpage.shopping_hall_sell_request.path,
  //     },
  //   },
  //   {
  //     type: 'class',
  //     link: {
  //       label: 'اعتبارسنجی',
  //       newTab: false,
  //       url: ProjectsRoute.map.mainpage.certificate_stock.path,
  //     },
  //   },
  //   {
  //     type: 'string',
  //     link: {
  //       label: 'وبلاگ',
  //       url: 'https://asghar.com',
  //       newTab: true,
  //     },
  //   },
  //   {
  //     type: 'class',
  //     link: {
  //       label: 'سوالات متداول',
  //       url: FaqRoute.map.mainpage.view_faqs.path,
  //       newTab: false,
  //     },
  //   },
  //   {
  //     type: 'class',
  //     link: {
  //       label: 'تماس باما',
  //       newTab: false,
  //       url: SiteManagmentRoute.map.mainpage.contact_us.path,
  //     },
  //   },
  // ];

  loginRegisterButton: BaseButtons<any> = {
    label: 'ورود/ثبت نام',
    prefixIcon: 'isax icon-user',
    class: 'btn btn-primary d-flex align-items-center font-',
    action: () => {
      AuthenticationRoute.map.full.authentication.root.navigate();
    },
    visibleCondition: JwtAuthTokenService.isAuthenticated$.pipe(
      map((isAuthenticated) => !isAuthenticated),
    ),
  };
  dashboardBtn: BaseButtons<any>;
  notificationCount: number = 0;

  constructor(
    private headerService: HeaderTemplateService,
    private _userService: UserService,
    private renderer2: Renderer2,
    private jwtAuthService: JwtAuthTokenService,
    private router: Router,
    private host: ElementRef,
    private renderer: Renderer2,
  ) { }

  ngOnInit() {
    // this.renderLinks();
    this.headerService.allTemplates$.subscribe((value) => {
      this.startHeaderTemplate = value.startHeader;
      this.itemHeaderTemplate = value.itemHeader;
      this.endHeaderTemplate = value.endHeader;
      this.buttonNavigateTemplate = value.buttonNavigateHeader;
    });
    this.items = [
      {
        url: '#/' + FaqRoute.map.mainpage.view_faqs.path,
        label: 'سوالات متداول',
      },
    ];
    JwtAuthTokenService.isAuthenticated$
      .pipe(
        switchMap((isAuthen) => {
          this.isAuthenticated = !!isAuthen;
          if (isAuthen) return this._userService.getNotificationCount();
          else return of(null);
        }),
        untilDestroyed(this),
      )
      .subscribe((count) => {
        this.notificationCount = count;
      });
    // this.loginRegisterButton = new MainButtonGroup({
    //   class: 'btn btn-primary d-flex align-items-center',
    //   buttons: [
    //     new NavigateButton({
    //       label: 'ورود/عضویت',
    //       // TODO:
    //       // visibleCondition: JwtAuthTokenService.isAuthenticated$.pipe(
    //       //   map((isAuthenticated) => !isAuthenticated),
    //       // ),
    //       iconClass: 'far fa-user mx-2',
    //       navigateOption: {
    //         subRoute: AuthenticationRoute.map.full.login,
    //       },
    //     }),
    //   ],
    // });
    this.checkUserAuthentication();
    this.makeDropDownMenu();
  }

  ngAfterViewChecked(): void {
    if (environment.TEST_MODE == 'enable') {
      this.setTokenInHeader();
    }
  }

  makeDropDownMenu() {
    this.dropDownOptions = [
      {
        label: 'پیام ها',
        icon: 'isax icon-notification',
        routerLink: AuthenticationRoute.map.dashboard.notifications,
        templateRef: this.notifPannelMenuRef,
      },
      {
        label: ' اطلاعات حساب کاربری',
        icon: 'isax icon-user',
        routerLink: AuthenticationRoute.map.dashboard.authentication,
      },
      {
        separator: true,
      },
      {
        label: 'خروج',
        icon: 'isax icon-logout',
        styleClass: 'logout-menu-item',
        command: () => {
          new LoginRequest.Delete(undefined)
            .call()
            .pipe(untilDestroyed(this))
            .subscribe(async (data) => {
              if (data?.response?.statusCode === 200) {
                await JwtAuthTokenService.clearToken();
                location.href = '/';
              }
            });
        },
      },
    ];
  }

  setTokenInHeader() {
    if (this.header?.nativeElement) {
      this.renderer2?.setProperty(
        this.header?.nativeElement,
        'setToken',
        (refreshToken) => {
          this.jwtAuthService.setTokens(refreshToken);
        },
      );
    }
  }
  private renderLinks() {
    // this.itemsLink.clear(); // Clear previous components

    this.items.forEach((link) => {
      HeaderRouteStrartegy.executeRouteStrategy(
        link.type,
        link.link,
        this.itemsLink,
      );
    });
  }

  phoneCall() {
    window.location.href = 'tel:03538342317';
  }

  checkUserAuthentication() {
    JwtAuthTokenService.isAuthenticated$
      .pipe(
        filter((isAuthen) => !!isAuthen),
        switchMap((data) => {
          const id = this._userService.getUserDetail()?.id;
          return new AppUserRequest.GetById({ id }).call();
        }),
        map((res) => res?.response?.data?.[0]),
        first(),
      )
      .subscribe((user) => {
        if (user) {
          this.userLoginBtnCreator(user);
        }
      });
  }

  private userLoginBtnCreator(user: AppUserModel.Full): void {
    const { firstName, lastName, mobileNumber } = user?.baseUser?.realPerson;
    this.dashboardBtn = {
      label: !!firstName?.length
        ? firstName + ' ' + lastName
        : !!mobileNumber?.length
          ? mobileNumber
          : user?.baseUser?.username,
      postfixIcon: 'isax icon-user',
      class:
        'd-flex align-items-center btn btn-outline-primary d-flex align-items-center',
      action: (event: MouseEvent) => {
        this.toggle(event);
      },
    };
  }

  navigateToPanel() {
    this.panelView.navigate();
  }

  toggle(event?: MouseEvent | Event) {
    if (event && (event as MouseEvent).target) {
      this.lastTriggerEl = (event as MouseEvent).target as Element;
    }
    this.opened = !this.opened;
    if (this.opened) {
      this.positionPanel();
    }
  }

  show(event?: MouseEvent | Event) {
    if (event && (event as MouseEvent).target) {
      this.lastTriggerEl = (event as MouseEvent).target as Element;
    }
    this.opened = true;
    this.positionPanel();
  }

  hide() {
    this.opened = false;
  }

  private positionPanel() {
    try {
      const panelEl: HTMLElement = this.panel?.nativeElement;
      const trigger = this.lastTriggerEl as HTMLElement;
      if (!trigger) {
        // default, position below host
        const hostRect = (
          this.host?.nativeElement as HTMLElement
        ).getBoundingClientRect();
        this.renderer.setStyle(panelEl, 'top', hostRect.bottom + 'px');
        this.renderer.setStyle(panelEl, 'left', hostRect.left + 'px');
        return;
      }
      const rect = trigger.getBoundingClientRect();
      // try placing menu under the trigger
      const top = rect.bottom + window.scrollY + 6; // small gap
      const left = rect.left + window.scrollX;
      this.renderer.setStyle(panelEl, 'position', 'absolute');
      this.renderer.setStyle(panelEl, 'top', `${top}px`);
      this.renderer.setStyle(panelEl, 'left', `${left}px`);
      this.renderer.setStyle(panelEl, 'z-index', '1100');
    } catch (e) {
      // ignore
    }
  }

  onItemClick(item: SimpleMenuItem, event: MouseEvent) {
    event.stopPropagation();
    if (item.command) {
      try {
        item.command(event);
      } catch (err) {
        console.error(err);
      }
      // keep menu open/close logic depending on your needs:
      this.hide();
      return;
    }
    if (item.routerLink) {
      // if (Array.isArray(item.routerLink)) item.routerLink
      // else this.router.navigateByUrl(item.routerLink);
      this.hide();
      return;
    }
    // if templateRef exists and used for badge, we still close after click
    this.hide();
  }

  @HostListener('document:click', ['$event'])
  onDocClick(event: MouseEvent) {
    if (!this.opened) return;
    const target = event.target as HTMLElement;
    // if click inside panel or inside trigger, do nothing
    if (
      this.host &&
      (this.host?.nativeElement as HTMLElement).contains(target)
    ) {
      // host contains the menu component area, but we must ensure we don't close when clicking the trigger
      return;
    }
    const panelEl = this.panel?.nativeElement as HTMLElement;
    if (panelEl && panelEl.contains && panelEl.contains(target)) {
      return;
    }
    // this.hide();
  }

  trackByIndex(i: number) {
    return i;
  }
}
